// exquisit beauty & more — theme interactions
(function () {
  'use strict';

  function fmtMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var locale = (window.Shopify && window.Shopify.locale) || 'de';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format((cents || 0) / 100);
    } catch (e) {
      return ((cents || 0) / 100).toFixed(2) + ' €';
    }
  }
  function escHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  document.addEventListener('DOMContentLoaded', function () {

    /* header height -> --header-h custom property (drives the hero overlap trick) */
    var headerEl = document.querySelector('.site-header');
    function setHeaderHeight() {
      if (!headerEl) return;
      document.documentElement.style.setProperty('--header-h', headerEl.offsetHeight + 'px');
    }
    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight);

    /* header scroll state */
    var onScroll = function () {
      if (window.scrollY > 40) headerEl && headerEl.classList.add('is-scrolled');
      else headerEl && headerEl.classList.remove('is-scrolled');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    /* header pin state — JS-driven position:fixed instead of native
       position:sticky (see comment in sections/exbm-header.liquid for why).
       Pins once you've scrolled past the announcement bar (or immediately,
       if there isn't one), and gives the spacer that same height so
       nothing below jumps when the header leaves normal flow. */
    var headerWrapper = document.getElementById('shopify-section-exbm-header');
    var headerSpacer = document.querySelector('[data-header-spacer]');
    var announcementBar = document.querySelector('.announcement-bar');
    var updateHeaderPin = function () {
      if (!headerWrapper) return;
      var threshold = announcementBar ? announcementBar.offsetHeight : 0;
      var shouldPin = window.scrollY >= threshold;
      var isPinned = headerWrapper.classList.contains('is-fixed');
      if (shouldPin) {
        if (!isPinned) headerWrapper.classList.add('is-fixed');
        // Keep the spacer synced to the header's *current* height even
        // while already pinned, not just at the moment it first pins —
        // covers cases where the header's own size changes later (font
        // load reflow, content edits) while scrolled.
        if (headerSpacer) headerSpacer.style.height = headerWrapper.offsetHeight + 'px';
      } else {
        if (isPinned) headerWrapper.classList.remove('is-fixed');
        if (headerSpacer) headerSpacer.style.height = '0px';
      }
    };
    updateHeaderPin();
    window.addEventListener('scroll', updateHeaderPin, { passive: true });
    window.addEventListener('resize', updateHeaderPin);
    /* iOS Safari's collapsing/expanding toolbar runs its own resize
       animation independent of scroll events — visualViewport.resize
       fires specifically when that settles, catching cases where the
       toolbar is still mid-animation when a scroll-driven pin/unpin
       already fired, momentarily misaligning the two. */
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', updateHeaderPin);
    }
    /* ResizeObserver catches the announcement bar or header actually
       changing size for *any* reason — a real viewport resize, a web
       font finishing its swap and reflowing text, or (notably) the
       Shopify Theme Editor's mobile-preview toggle, which resizes its
       preview iframe without necessarily firing a normal window resize
       event, leaving our scroll/resize-driven measurement stale. */
    if (window.ResizeObserver) {
      var headerResizeObserver = new ResizeObserver(function () { updateHeaderPin(); });
      if (announcementBar) headerResizeObserver.observe(announcementBar);
      headerResizeObserver.observe(headerWrapper);
    }

    /* video mute/unmute toggle (media-split sections with sound) */
    document.querySelectorAll('[data-video-mute-toggle]').forEach(function (btn) {
      var wrap = btn.closest('.video-audio-wrap');
      var video = wrap && wrap.querySelector('video');
      if (!video) return;
      btn.addEventListener('click', function () {
        video.muted = !video.muted;
        btn.classList.toggle('is-muted', video.muted);
        btn.setAttribute('aria-label', video.muted ? 'Ton einschalten' : 'Ton ausschalten');
      });
    });

    /* mobile nav toggle */
    var toggle = document.querySelector('.nav-toggle');
    if (toggle) {
      toggle.addEventListener('click', function () {
        document.body.classList.toggle('nav-open');
      });
      document.querySelectorAll('.main-nav a').forEach(function (a) {
        a.addEventListener('click', function () { document.body.classList.remove('nav-open'); });
      });
      var backdrop = document.querySelector('[data-nav-backdrop]');
      if (backdrop) {
        backdrop.addEventListener('click', function () { document.body.classList.remove('nav-open'); });
      }
    }

    /* scroll reveal */
    var revealEls = document.querySelectorAll('.reveal');
    if ('IntersectionObserver' in window && revealEls.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
      revealEls.forEach(function (el) { io.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('is-visible'); });
    }

    /* accordion */
    document.querySelectorAll('.accordion-item').forEach(function (item) {
      var btn = item.querySelector('button');
      var panel = item.querySelector('.accordion-panel');
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('open');
        item.parentElement.querySelectorAll('.accordion-item.open').forEach(function (other) {
          if (other !== item) {
            other.classList.remove('open');
            other.querySelector('.accordion-panel').style.maxHeight = null;
          }
        });
        if (isOpen) {
          item.classList.remove('open');
          panel.style.maxHeight = null;
        } else {
          item.classList.add('open');
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });

    /* file upload filename display */
    document.querySelectorAll('[data-upload-name]').forEach(function (input) {
      var label = input.closest('.upload-row').querySelector('.upload-filename');
      input.addEventListener('change', function () {
        label.textContent = input.files.length ? input.files[0].name : 'Keine Datei ausgewählt';
      });
    });

    /* quantity selector (generic — used on PDP and anywhere .qty-select appears) */
    document.querySelectorAll('.qty-select').forEach(function (sel) {
      var span = sel.querySelector('[data-qty]') || sel.querySelector('span');
      var minus = sel.querySelector('.qty-minus');
      var plus = sel.querySelector('.qty-plus');
      function get() { return parseInt(span.textContent, 10) || 1; }
      if (minus) minus.addEventListener('click', function () { span.textContent = Math.max(1, get() - 1); });
      if (plus) plus.addEventListener('click', function () { span.textContent = get() + 1; });
    });

    /* ---------------------------------------------------------------
       Product variant picker — real Shopify variants (e.g. length).
       Each PDP embeds its variants as JSON via a script tag; option
       buttons carry data-option-name/data-option-value and we resolve
       the matching variant, then update price / ATC state / gallery.
       --------------------------------------------------------------- */
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      var dataEl = form.querySelector('[data-product-json]');
      if (!dataEl) return;
      var product;
      try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var selected = {};
      form.querySelectorAll('.option-group[data-option-name]').forEach(function (group) {
        var active = group.querySelector('.length-chip.active, [data-option-value].active');
        if (active) selected[group.dataset.optionName] = active.dataset.optionValue;
      });

      var variantIdInput = form.querySelector('[name="id"]');
      var priceEl = form.querySelector('[data-variant-price]');
      var comparePriceEl = form.querySelector('[data-variant-compare-price]');
      var atcBtn = form.querySelector('[data-atc-button]');
      var galleryImg = document.querySelector('[data-gallery-main]');

      function findVariant() {
        return product.variants.find(function (v) {
          return v.options.every(function (optValue, i) {
            var optName = product.options[i];
            return !selected[optName] || selected[optName] === optValue;
          });
        });
      }

      function render() {
        var variant = findVariant();
        if (!variant) return;
        if (variantIdInput) variantIdInput.value = variant.id;
        if (priceEl) priceEl.textContent = fmtMoney(variant.price);
        if (comparePriceEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            comparePriceEl.textContent = fmtMoney(variant.compare_at_price);
            comparePriceEl.hidden = false;
          } else {
            comparePriceEl.hidden = true;
          }
        }
        if (atcBtn) {
          if (variant.available) {
            atcBtn.disabled = false;
            atcBtn.dataset.variantId = variant.id;
            atcBtn.textContent = atcBtn.dataset.labelAvailable || 'In den Warenkorb';
          } else {
            atcBtn.disabled = true;
            atcBtn.textContent = atcBtn.dataset.labelSoldOut || 'Ausverkauft';
          }
        }
        if (galleryImg && variant.featured_image) {
          galleryImg.src = variant.featured_image.src.replace(/(\.[a-z]{3,4})(\?|$)/i, '_800x$1$2');
        }
      }

      form.querySelectorAll('.option-group[data-option-name]').forEach(function (group) {
        group.querySelectorAll('[data-option-value]').forEach(function (chip) {
          chip.addEventListener('click', function () {
            group.querySelectorAll('[data-option-value]').forEach(function (c) { c.classList.remove('active'); });
            chip.classList.add('active');
            selected[group.dataset.optionName] = chip.dataset.optionValue;
            render();
          });
        });
      });

      render();
    });

    /* product gallery thumbnails */
    document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var main = document.querySelector('[data-gallery-main]');
        if (main && thumb.dataset.full) main.src = thumb.dataset.full;
      });
    });

    /* ---------------------------------------------------------------
       Cart drawer
       --------------------------------------------------------------- */
    var drawer = document.querySelector('.cart-drawer');
    var backdrop = document.querySelector('.cart-drawer-backdrop');
    var drawerBody = drawer && drawer.querySelector('.cart-drawer-body');
    var drawerFoot = drawer && drawer.querySelector('.cart-drawer-foot');
    var drawerError = drawer && drawer.querySelector('[data-cart-error]');
    var cartCountEls = document.querySelectorAll('.cart-count');

    function openDrawer() {
      if (!drawer) return;
      drawer.classList.add('is-open');
      backdrop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    function showCartError(message) {
      if (!drawerError) return;
      drawerError.textContent = message;
      drawerError.hidden = false;
    }
    function hideCartError() {
      if (!drawerError) return;
      drawerError.hidden = true;
    }
    function updateCartCount(count) {
      cartCountEls.forEach(function (el) {
        el.textContent = count;
        el.hidden = count === 0;
      });
    }
    function renderDrawer(cart) {
      /* Shopify's cart endpoints return a plain {status, message, description}
         object (not a cart) on errors like insufficient inventory — never let
         that shape wipe the drawer to a false "empty cart" state. */
      if (!drawerBody || !cart || typeof cart.item_count !== 'number') return;
      updateCartCount(cart.item_count);
      if (!cart.item_count) {
        drawerBody.innerHTML = '<p class="cart-drawer-empty">Dein Warenkorb ist leer.</p>';
        if (drawerFoot) drawerFoot.hidden = true;
        return;
      }
      if (drawerFoot) drawerFoot.hidden = false;
      var html = cart.items.map(function (item) {
        var img = item.image ? item.image.replace(/(\.[a-z]{3,4})(\?|$)/i, '_160x$1$2') : '';
        var variantTitle = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
        return (
          '<div class="cart-line" data-key="' + item.key + '" data-line-id="' + item.id + '">' +
            (img ? '<img src="' + img + '" alt="' + escHtml(item.product_title) + '" loading="lazy">' : '<div></div>') +
            '<div>' +
              '<p class="cart-line-title">' + escHtml(item.product_title) + '</p>' +
              (variantTitle ? '<p class="cart-line-variant">' + escHtml(variantTitle) + '</p>' : '') +
              '<div class="cart-line-qty">' +
                '<button type="button" data-action="dec" aria-label="Menge verringern">–</button>' +
                '<span data-qty>' + item.quantity + '</span>' +
                '<button type="button" data-action="inc" aria-label="Menge erhöhen">+</button>' +
              '</div>' +
              '<div class="cart-line-row">' +
                '<div class="cart-line-price" data-line-price>' + fmtMoney(item.final_line_price) + '</div>' +
                '<button type="button" class="cart-line-remove" data-action="remove">Entfernen</button>' +
              '</div>' +
            '</div>' +
          '</div>'
        );
      }).join('');
      drawerBody.innerHTML = html;
      var subtotalEl = drawerFoot && drawerFoot.querySelector('[data-cart-subtotal]');
      if (subtotalEl) subtotalEl.textContent = fmtMoney(cart.total_price);
    }
    function refreshCart() {
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(renderDrawer);
    }
    window.exbmCart = { open: openDrawer, close: closeDrawer, refresh: refreshCart };

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-open-cart-drawer]')) {
        e.preventDefault();
        refreshCart().then(openDrawer);
      }
      if (e.target.closest('.cart-drawer-close') || e.target === backdrop) {
        closeDrawer();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    /* ---------------------------------------------------------------
       Search drawer
       --------------------------------------------------------------- */
    var searchDrawer = document.querySelector('.search-drawer');
    var searchBackdrop = document.querySelector('.search-drawer-backdrop');
    var searchInput = searchDrawer && searchDrawer.querySelector('[data-search-input]');

    function openSearchDrawer() {
      if (!searchDrawer) return;
      searchDrawer.classList.add('is-open');
      searchBackdrop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (searchInput) setTimeout(function () { searchInput.focus(); }, 200);
    }
    function closeSearchDrawer() {
      if (!searchDrawer) return;
      searchDrawer.classList.remove('is-open');
      searchBackdrop.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    window.exbmSearch = { open: openSearchDrawer, close: closeSearchDrawer };

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-open-search-drawer]')) {
        e.preventDefault();
        openSearchDrawer();
      }
      if (e.target.closest('[data-search-close]') || e.target === searchBackdrop) {
        closeSearchDrawer();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSearchDrawer();
    });

    /* qty +/- and remove inside the drawer — delegated from document */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.cart-line button[data-action]');
      if (!btn) return;
      var line = btn.closest('.cart-line');
      var key = line.dataset.key;
      var cur = parseInt(line.querySelector('[data-qty]').textContent, 10) || 1;
      var action = btn.dataset.action;
      var next = action === 'inc' ? cur + 1 : action === 'dec' ? Math.max(0, cur - 1) : 0;
      hideCartError();
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: next })
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (result) {
          if (!result.ok) {
            showCartError(result.data.description || result.data.message || 'Menge konnte nicht geändert werden.');
            return refreshCart();
          }
          renderDrawer(result.data);
        });
    });

    /* global add-to-cart handler */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.btn-atc-shop[data-variant-id]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = '…';
      hideCartError();
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: btn.dataset.variantId, quantity: parseInt(btn.dataset.quantity, 10) || 1 })
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (result) {
          if (!result.ok) {
            showCartError(result.data.description || result.data.message || 'Artikel konnte nicht hinzugefügt werden.');
          }
          return refreshCart();
        })
        .then(function () { openDrawer(); })
        .catch(function () {})
        .finally(function () {
          btn.disabled = false;
          btn.textContent = original;
        });
    });

  });
})();
